import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setLoader } from "./MasterSlice";
import * as API from "../../utils/api.services";
import { TOAST_SUCCESS } from "../../config/common";

export const getDashbaordListApiCall = createAsyncThunk("Dashboard_Count", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true))
        const { data: dashboardList } = await API.dashboardCount(submitData);
        dispatch(setLoader(false))
        return dashboardList;
    } catch (error) {
        throw error;
    }
});



const initialState = {
    categoryList: {
        data: [],
        error: null,
    },
    editCategoryData: {
        data: null,
        code: '',
        message: '',
        error: null,
    },
    subCategoryList: {
        data: [],
        error: null,
    },
    editSubCategoryData: {
        data: null,
        code: '',
        message: '',
        error: null,
    },
    categoryWishSubCategoryList: {
        data: [],
        code: '',
        error: null,
    },
};

const categorySlice = createSlice({
    name: "categorySlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getDashbaordListApiCall.pending, (state, action) => {
                state.categoryList.data = action.payload;
            })
            .addCase(getDashbaordListApiCall.rejected, (state, action) => {
                state.categoryList.error = action.error.message;
            })
            .addCase(getDashbaordListApiCall.fulfilled, (state, action) => {
                const { message, code, data } = action.payload;
                state.editCategoryData.data = data;
                state.editCategoryData.message = message;
                state.editCategoryData.code = code;
            })
       
    },
});

export default categorySlice.reducer;